var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10666 2.55395C2.27204 2.22692 2.61212 2 3.00009 2H19.0001C19.3881 2 19.7281 2.22692 19.8935 2.55395L11.0001 8.77934L2.10666 2.55395ZM0.000135348 2.98266C-2.68281e-05 2.99253 -4.31758e-05 3.00239 8.58362e-05 3.01225V15C8.58362e-05 16.6523 1.3478 18 3.00009 18H19.0001C20.6524 18 22.0001 16.6523 22.0001 15V3.01236C22.0002 3.00242 22.0002 2.99247 22 2.98251C21.9906 1.33822 20.6465 0 19.0001 0H3.00009C1.35359 0 0.00952624 1.3383 0.000135348 2.98266ZM20.0001 4.92066V15C20.0001 15.5477 19.5478 16 19.0001 16H3.00009C2.45237 16 2.00009 15.5477 2.00009 15V4.92066L10.4266 10.8192C10.7709 11.0603 11.2292 11.0603 11.5735 10.8192L20.0001 4.92066Z",
    fill: "#0C1D59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6d4cb5d449c3facb52db96502e2d2ad6.svg";
export { ForwardRef as ReactComponent };